module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagea"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f00vii-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Bert Bell, NFL commissioner 1946–1959. (Courtesy of "), _c('em', [_vm._v("The Sporting News")]), _vm._v("/Zuma Press)")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f00vii-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Giants third-quarter goal-line stand. (Courtesy of Hy Peskin/"), _c('em', [_vm._v("Sports Illustrated")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "imagea"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0viii-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("New York assistant coach Tom Landry (with ball) and the Giants’ defense, Nov. 6, 1958. (Courtesy of AP)")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0viii-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Baltimore head coach, Weeb Ewbank, briefs his team on the day before the big game, Dec. 27, 1958. (Courtesy of AP)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0ebcd42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/photos.vue
// module id = 78
// module chunks = 0